var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "main" },
      [
        _vm.modalIsOpen
          ? _c("app-modal-redefinirSenha", {
              staticClass: "modalSenha",
              on: { closeModal: _vm.closeModalRedefinirSenha }
            })
          : _vm._e(),
        _c(
          "el-card",
          { staticClass: "box-card" },
          [
            _c(
              "validation-observer",
              { ref: "observer", attrs: { tag: "form" } },
              [
                _c(
                  "form",
                  {
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.logar()
                      }
                    }
                  },
                  [
                    _vm.isAmbienteTeste
                      ? _c("img", {
                          staticClass: "logo",
                          attrs: {
                            src: require("../../../assets/images/logo.png")
                          },
                          on: {
                            click: function($event) {
                              return _vm.activeFake()
                            }
                          }
                        })
                      : _c("img", {
                          staticClass: "logo",
                          attrs: {
                            src: require("../../../assets/images/logo.png")
                          }
                        }),
                    _c(
                      "div",
                      { staticClass: "item" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required|cpf_cnpj", mode: "lazy" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("el-input", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: [
                                          "###.###.###-##",
                                          "##.###.###/####-##"
                                        ],
                                        expression:
                                          "['###.###.###-##', '##.###.###/####-##']"
                                      }
                                    ],
                                    staticClass: "input",
                                    class: { erro: errors.length },
                                    attrs: {
                                      placeholder: "CPF/CNPJ",
                                      id: "input_cpf",
                                      masked: "true"
                                    },
                                    model: {
                                      value: _vm.login,
                                      callback: function($$v) {
                                        _vm.login = $$v
                                      },
                                      expression: "login"
                                    }
                                  }),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "item" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required", mode: "lazy" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("el-input", {
                                    staticClass: "input",
                                    class: { erro: errors.length },
                                    attrs: {
                                      placeholder: "Senha",
                                      id: "input_senha",
                                      type: "password"
                                    },
                                    model: {
                                      value: _vm.senha,
                                      callback: function($$v) {
                                        _vm.senha = $$v
                                      },
                                      expression: "senha"
                                    }
                                  }),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "item" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "full-width",
                            attrs: { disabled: _vm.loading, type: "success" },
                            on: {
                              click: function($event) {
                                return _vm.logar()
                              }
                            }
                          },
                          [
                            !_vm.loading
                              ? _c("span", [_vm._v("Entrar")])
                              : _c("i", { staticClass: "el-icon-loading" })
                          ]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "buttons" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function($event) {
                            return _vm.openModalRedefinirSenha()
                          }
                        }
                      },
                      [_c("span", [_vm._v("Redefinir senha")])]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function($event) {
                            return _vm.criarConta()
                          }
                        }
                      },
                      [_c("span", [_vm._v("Criar conta")])]
                    )
                  ],
                  1
                )
              ]
            )
          ],
          1
        ),
        _vm.loginBovBr
          ? _c(
              "div",
              { staticClass: "login-gov-br" },
              [
                _c("el-divider", { attrs: { "content-position": "center" } }, [
                  _c("span", [_vm._v("ou")])
                ]),
                _c(
                  "div",
                  { staticClass: "item" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "full-width button-gov-br",
                        attrs: { disabled: _vm.loading, type: "success" },
                        on: { click: _vm.logarGov }
                      },
                      [
                        _c("span", [_vm._v("Entrar com")]),
                        _c("span", { staticClass: "gov-br" }, [
                          _vm._v(" gov.br")
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ],
      1
    ),
    _vm.listaUsuarios && _vm.listaUsuarios.length > 0
      ? _c(
          "div",
          { staticClass: "list-user" },
          [
            _c(
              "el-table",
              { attrs: { data: _vm.listaUsuarios } },
              [
                _c("template", { slot: "empty" }, [
                  _vm._v("Não há registros.")
                ]),
                _c("el-table-column", {
                  attrs: {
                    prop: "pessoa.nomeRazaoSocial",
                    label: "Nome/Razão Social",
                    width: "auto"
                  }
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "pessoa.cpfCnpj",
                    label: "CPF/CNPJ",
                    width: "auto"
                  }
                }),
                _c("el-table-column", {
                  attrs: { prop: "perfis", align: "left", label: "Perfis" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "lista" },
                              _vm._l(scope.row.perfis, function(perfil) {
                                return _c("ul", [
                                  _c("li", [_vm._v(_vm._s(perfil.nome))])
                                ])
                              }),
                              0
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    1882640062
                  )
                }),
                _c("el-table-column", {
                  attrs: { label: "Ações", width: "120", align: "center" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", size: "small" },
                                on: {
                                  click: function($event) {
                                    return _vm.fakeLogin(scope.row)
                                  }
                                }
                              },
                              [_vm._v("Login")]
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    1361531237
                  )
                })
              ],
              2
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30ab22b5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30ab22b5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/seguranca/Login.vue
// module id = null
// module chunks = 